import {
  INITIALNOTIFICATION_LIST,
  LOADMORENOTIFICATION_LIST,
  DEDUCTNOTIFICATION_COUNT,
  INITIAL_NOTIFICATION_READ,
  LOADMORE_NOTIFICATION_READ,
  RESET_INITIALNOTIFICATION_LIST,
  DEDUCT_MAIL_NOTIFICATION_COUNT
} from "./actionType";

const intialState = {
  notificationList: [],
  payloadEmpty: false,
  unreadCount: 0,
  unreadMailCount:0,
};

const deduplicateById = (items = []) => {
  const seen = new Set();
  const result = [];
  for (const item of items) {
    if (item && item.id != null) {
      if (!seen.has(item.id)) {
        seen.add(item.id);
        result.push(item);
      }
    } else if (item) {
      result.push(item);
    }
  }
  return result;
};

const notification = (state = intialState, action) => {
  switch (action.type) {
    case INITIALNOTIFICATION_LIST:
      return {
        ...state,
        notificationList: deduplicateById(action.payload?.rows || []),
        unreadCount: action.payload?.unreadCount,
        unreadMailCount: action.payload?.unreadMailCount,
      };
    case RESET_INITIALNOTIFICATION_LIST:
      return intialState;
    case LOADMORENOTIFICATION_LIST: {
      const existingIds = new Set(
        (state.notificationList || []).map((n) => n.id).filter(Boolean)
      );
      const newItems = (action.payload?.rows || [])
        .filter((notification) => !notification?.id || !existingIds.has(notification.id))
        .map((notification) => {
          return { ...notification, isRead: false };
        });
      return {
        ...state,
        notificationList: [...state.notificationList, ...newItems],
        unreadCount: action.payload?.unreadCount,
        unreadMailCount: action.payload?.unreadMailCount,
      };
    }
    case INITIAL_NOTIFICATION_READ:
      return {
        ...state,
        notificationList: deduplicateById(
          (action.payload || []).map((notification) => {
            return { ...notification, isRead: true };
          })
        ),
      };
    case LOADMORE_NOTIFICATION_READ:
      return {
        ...state,
        notificationList: deduplicateById([
          ...state.notificationList,
          ...(action.payload || []).map((notification) => {
            return { ...notification, isRead: true };
          }),
        ]),
      };
    case DEDUCTNOTIFICATION_COUNT:
      return { ...state, unreadCount: action.payload.unreadCount };
    case DEDUCT_MAIL_NOTIFICATION_COUNT: {
      let nextCount;
      if (action.payload && typeof action.payload.unreadMailCount === "number") {
        nextCount = action.payload.unreadMailCount;
      } else if (typeof action.payload === "number") {
        nextCount = action.payload;
      } else {
        nextCount = Math.max(0, (state.unreadMailCount || 0) - 1);
      }
      return { ...state, unreadMailCount: Math.max(0, nextCount) };
    } 
    default:
      return state;
  }
};

export default notification;
